import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "discount-bubble",
  "use": "discount-bubble-usage",
  "viewBox": "0 0 23 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 24\" id=\"discount-bubble\"><path clip-rule=\"evenodd\" d=\"M21.79 12a3.49 3.49 0 00-2.355-3.338 3.6 3.6 0 00-.61-4.087 3.286 3.286 0 00-3.941-.632 3.341 3.341 0 00-6.436 0 3.288 3.288 0 00-3.942.632 3.6 3.6 0 00-.61 4.087 3.542 3.542 0 000 6.675 3.6 3.6 0 00.61 4.087 3.288 3.288 0 003.942.633 3.341 3.341 0 006.436 0 3.286 3.286 0 003.94-.633 3.6 3.6 0 00.61-4.087A3.49 3.49 0 0021.792 12z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M8.291 15.75l7.5-7.5\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path clip-rule=\"evenodd\" d=\"M9.041 10.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM15.041 16.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/discount-bubble.svg
// module id = nTJI
// module chunks = 38 43